'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConsentToCommunicateMessage = undefined;

var _reselect = require('reselect');

var _WidgetDataModel = require('conversations-schema/models/WidgetDataModel');

var WidgetDataModel = _interopRequireWildcard(_WidgetDataModel);

var _getWidgetData = require('./getWidgetData');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getConsentToCommunicateMessage = exports.getConsentToCommunicateMessage = (0, _reselect.createSelector)(_getWidgetData.getWidgetData, function (widgetData) {
  return WidgetDataModel.getConsentToCommunicateMessage(widgetData);
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getConsentToCommunicateMessage.js
// module id = 1069
// module chunks = 2 3